module.exports = __webpack_public_path__ + "static/media/item-accounts.5ac742b4.svg";